module.exports = {
    blog_title:'Taption Blog',
    blog_desc:'Useful articles and helpful advice for creators. Product updates, news and info from Taption.',
    written_by: 'Written by', 
}